<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_user.user_detail')"
           fixed-tabs>
    <template #content>
      <v-container class="edit-operator-content" fluid v-if="operator">
        <v-tabs fixed-tabs
                v-model="tabIndex">
          <v-tab>{{ $t('register.basic_info') }}</v-tab>
          <v-tab-item>
            <v-container fluid>
              <v-form ref="operatorForm">
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  :label="$t('register.email')"
                                  v-model="operator.account.email"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-radio-group :label="$t('admin_operator.user_type')"
                                   v-model="operator.account.type">
                      <v-radio :label="$t('account_type.operator')"
                               :value="100"></v-radio>
                      <v-radio :label="$t('account_type.admin')"
                               :value="369"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <b-form-group :label="$t('admin_operator.permissions')"
                              v-if="operator.account.type === 100">
                  <OperatorPermissionSelector v-model="permissions"></OperatorPermissionSelector>
                </b-form-group>
                <v-row v-if="operator.account.type === 100">
                  <v-col>
                    <v-btn block @click="permissions=[...permissionPreSetAccAdmin]">{{ $t('admin_operator.permission_pre_set_acc_admin') }}</v-btn>
                  </v-col>
                  <v-col>
                    <v-btn block @click="permissions=[...permissionPreSetHkiaraceAdmin]">{{ $t('admin_operator.permission_pre_set_hkiarace_admin') }}</v-btn>
                  </v-col>
                  <v-col>
                    <v-btn block @click="permissions=[...permissionPreSetHelper]">{{ $t('admin_operator.permission_pre_set_helper') }}</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-tab-item>

          <v-tab>{{ $t('admin_operator.managed_events') }}</v-tab>
          <v-tab-item>
            <AdminEventList full-height
                            show-select
                            v-model="managedEvents"
                            v-if="tabIndex === 1"></AdminEventList>
          </v-tab-item>

        </v-tabs>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.operatorForm.validate() && saveOperator()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";
import OperatorPermissionSelector from "@/components/operator/OperatorPermissionSelector";
import AdminEventList from "@/components/event/AdminEventList";

export default {
  name: 'EditOperatorModal',
  components: {AdminEventList, OperatorPermissionSelector, BGModal},
  props: {
    shown: Boolean,
    operatorId: String,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    const tabIndex = ref(0);

    // Init
    watch(() => props.shown, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          tabIndex.value = 0;
          getOperator();
        }
      }

      tabIndex.value = 0;
    });
    const cancel = function () {
      emit('cancel');
    };
    const getOperator = function () {
      root.$callAPI('hkiarace/admin/operator/', {id: props.operatorId}, function (response) {
        operator.value = response.body.operator;
        permissions.value = response.body.operator.permissions;
        managedEvents.value = response.body.operator.managed_events.map(e => e.id);
      });
    }

    // Info
    const operator = ref(null);
    const permissions = ref([]);
    const permissionPreSetAccAdmin = ref(["acc.dashboard", "acc.setup_facility", "acc.list_booking", "acc.check_in", "acc.edit_booking", "acc.cancel_booking", "acc.maintenance"])
    const permissionPreSetHkiaraceAdmin = ref(['hkiarace']);
    const permissionPreSetHelper = ref(['hkiarace.list_event', 'hkiarace.check_in']);

    const saveOperator = function () {
      root.$callAPI('hkiarace/admin/operator/edit/', {
        id: operator.value.account.id,
        type: operator.value.account.type,
        permissions: permissions.value,
        managed_events: managedEvents.value,
      }, () => {
        root.$showAlertMessage('Info Saved');
        getOperator();
      })
    }


    // Managed Events
    const managedEvents = ref(["82bd3534-0519-45a8-88f0-a6da76b2454a"]);

    return {
      dialogShown,
      tabIndex,

      cancel,

      // Info
      operator,
      permissions,
      permissionPreSetAccAdmin,
      permissionPreSetHkiaraceAdmin,
      permissionPreSetHelper,

      saveOperator,

      // Managed Events
      managedEvents,
    }
  }
}
</script>

<style lang="less">
.edit-operator-content {
  display: flex;
  height: 100%;
}
</style>
